import initializeConfig from "utils/requests/api.config";
import RequestNoCredentials from "utils/requests/api.noCredentials";

export type ILocation = {
  id: number;
  description: string;
};

export interface IRequestPostNewUser {
  location: ILocation;
  name: string;
  email: string;
  language: string;
}

export const BASE_URL_IDENTITY = async () => {
  const { identity } = await initializeConfig();
  return `${identity}`;
};

export const getToken = async (body) => {
  const baseUrlIdentity = await BASE_URL_IDENTITY();
  return (await RequestNoCredentials).get(`${baseUrlIdentity}authentications:token`, body);
};

export const saveNewUser = async (params: IRequestPostNewUser) => {
  const baseUrl = await BASE_URL_IDENTITY();
  return (await RequestNoCredentials).post(`${baseUrl}users/:public`, params);
};
